import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import {
    headers, getExhibitionProgramMasterUrl,
    getExhibitionProgramDetailsMasterUrl,
    getExhibitionProgramListMasterUrl,
    insertProgramMasterUrl,
    updateProgramMasterUrl,
    GET_PROGRAM_MASTER,
    GET_PROGRAM_DETAIL_MASTER,
    GET_PROGRAM_MASTER_LIST,
    INSERT_PROGRAM_MASTER,
    UPDATE_PROGRAM_MASTER, deleteProgramMasterUrl
} from "../../../utils/constants";


export const deleteProgramMaster_action = (ExhProgramID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ExhProgramID: ExhProgramID,
        }

        const res = await axiosGet(deleteProgramMasterUrl, params, headers)

        dispatch({
            type: GET_PROGRAM_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getExhibitionProgramMaster_action = (ExhibitionID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID,
            // CompanyName: CompanyName,
            // Status: Status,
        }

        const res = await axiosGet(getExhibitionProgramMasterUrl, params, headers)

        dispatch({
            type: GET_PROGRAM_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getExhibitionProgramDetailsMaster_action = (ExhProgramID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ExhProgramID: ExhProgramID,
            // Status: Status,
        }

        const res = await axiosGet(getExhibitionProgramDetailsMasterUrl, params, headers)

        dispatch({
            type: GET_PROGRAM_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getExhibitionProgramListMaster_action = (ExhibitionID, ProgramName, Date) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID,
            ProgramName: ProgramName,
            Date: Date,
        }

        const res = await axiosGet(getExhibitionProgramListMasterUrl, params, headers)

        dispatch({
            type: GET_PROGRAM_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertProgramMaster_action = (ExhProgramList, ExhProgramDateList, ExhProgramCategory) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ExhProgramList: ExhProgramList,
            ExhProgramDateList: ExhProgramDateList,
            ExhProgramCategory: ExhProgramCategory,
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosPost(insertProgramMasterUrl, params, headers)

        dispatch({
            type: INSERT_PROGRAM_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updateProgramMaster_action = (ExhProgramList, ExhProgramDateList, ExhProgramCategory) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ExhProgramList: ExhProgramList,
            ExhProgramDateList: ExhProgramDateList,
            ExhProgramCategory: ExhProgramCategory,
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosPost(updateProgramMasterUrl, params, headers)

        dispatch({
            type: INSERT_PROGRAM_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}